import { useEffect } from "react";
import { useVertical } from "@/shared/contexts/VerticalContext";
import { useIsCreator } from "@/shared/hooks/useIsCreator";
import { DashboardShell } from "@/shared/dashboard/DashboardShell";

export function DashboardPage() {
  const { verticalConfig, loading, resolved } = useVertical();
  const { isCreator, loading: creatorLoading } = useIsCreator();
  const handleNavigate = (path: string) => (window as any).navigate(path);

  // Invited creators are workspace-only: any /dashboard visit routes to their
  // course-management workspace. This must WIN over the vertical homePage
  // redirect below, so that one waits for the creator check to resolve.
  useEffect(() => {
    if (!creatorLoading && isCreator) handleNavigate("/creator");
  }, [creatorLoading, isCreator]);

  // homePage escape hatch: if a vertical's config declares homePage != "dashboard",
  // redirect to that route (only "general" does today -> /courses). Gate on
  // `resolved`, not just `!loading`: the context boots on DEFAULT_VERTICAL
  // (general, homePage "courses"), and a failed/early-returned profile load can
  // flip loading false while still on that transient default — redirecting then
  // would bounce every other vertical's /dashboard to /courses.
  const homePage = verticalConfig.dashboard.homePage;
  useEffect(() => {
    if (creatorLoading || isCreator) return; // creator redirect above wins
    if (!loading && resolved && homePage && homePage !== "dashboard")
      handleNavigate(`/${homePage}`);
  }, [homePage, loading, resolved, creatorLoading, isCreator]);

  return <DashboardShell />;
}
